import React, { useState, useEffect, useRef } from "react";
import "./SalesReport.css";
export default function SalesReportFilter({ fromDate, toDate }) {

  const [salesType, setSalesType] = useState("ALL");
  const [partyList, setPartyList] = useState([]);
  const [selectedParty, setSelectedParty] = useState("");
  const [selectedPartyId, setSelectedPartyId] = useState(null);



  const [showPartyPopup, setShowPartyPopup] = useState(false);
  const [partySearch, setPartySearch] = useState("");
  const [activeIndex, setActiveIndex] = useState(0);

  const [reportData, setReportData] = useState([]);
  const [loading, setLoading] = useState(false);

  const popupRef = useRef(null);

  // Fetch parties
  useEffect(() => {
    fetch("http://103.79.74.237:8081/api/party")
      .then(res => res.json())
      .then(data => setPartyList(data))
      .catch(err => console.error(err));
  }, []);

  // Filter + sort
 const filteredParties = partyList
  .filter(p =>
    p.partyName?.toLowerCase().includes(partySearch.toLowerCase())
  )
  .sort((a, b) =>
    a.partyName.localeCompare(b.partyName)
  );


  // Keyboard navigation
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!showPartyPopup) return;

      if (e.key === "ArrowDown") {
        setActiveIndex(prev =>
          prev < filteredParties.length - 1 ? prev + 1 : prev
        );
      }

      if (e.key === "ArrowUp") {
        setActiveIndex(prev =>
          prev > 0 ? prev - 1 : prev
        );
      }

      if (e.key === "Enter") {
        if (filteredParties[activeIndex]) {
          selectParty(filteredParties[activeIndex]);
        }
      }

      if (e.key === "Escape") {
        setShowPartyPopup(false);
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [showPartyPopup, filteredParties, activeIndex]);

  // Select party
  const selectParty = (party) => {
    setSelectedParty(party.partyName);
    setSelectedPartyId(party.id);
    setShowPartyPopup(false);
  };

  // Preview
const handlePrint = async () => {

  if (!fromDate || !toDate) {
    alert("Please select From and To dates");
    return;
  }

  if (salesType === "PARTY" && !selectedPartyId) {
    alert("Please select party");
    return;
  }

  try {

    let url = `http://127.0.0.1:8081/api/reports/sales?type=${salesType}&from=${fromDate}&to=${toDate}`;

    if (salesType === "PARTY") {
      url += `&partyId=${selectedPartyId}`;
    }

    const response = await fetch(url);

    if (!response.ok) {
      throw new Error("Failed to load report");
    }

    const data = await response.json();

    if (!data || data.length === 0) {
      alert("No data found");
      return;
    }

    generatePrintPage(data);

  } catch (error) {
    console.error(error);
    alert("Failed to load report");
  }
};

const generatePrintPage = (data) => {

  const totalAmount = data.reduce((s, r) => s + Number(r.amount || 0), 0);
  const totalReceipt = data.reduce((s, r) => s + Number(r.receipt || 0), 0);
  const totalBalance = data.reduce((s, r) => s + Number(r.balance || 0), 0);

  const printWindow = window.open("", "_blank");

  printWindow.document.write(`
    <html>
    <head>
      <title>Sales Report</title>
      <style>
        body {
          font-family: Arial, sans-serif;
          padding: 20px;
        }

        .report-wrapper {
          border: 2px solid #000;
          padding: 10px;
        }

        .header-box {
          border-bottom: 2px solid #000;
          padding-bottom: 10px;
          margin-bottom: 10px;
          text-align: center;
        }

        .header-box h2 {
          margin: 0;
        }

       .header-section {
  position: relative;
  margin-bottom: 15px;
}

.company-section {
  text-align: center;
}

.title {
  font-size: 20px;
  font-weight: bold;
}

.sub-title {
  margin-top: 4px;
  font-size: 14px;
}

.date-section {
  position: absolute;
  right: 0;
  top: 0;
  text-align: right;
  font-weight: bold;
  font-size: 14px;
}

        table {
          width: 100%;
          border-collapse: collapse;
        }

        th, td {
          border: 1px solid #000;
          padding: 6px;
          font-size: 14px;
          text-align: center;
        }

        th {
          background: #eaeaea;
        }

        td:first-child {
          text-align: left;
        }

        tfoot td {
          font-weight: bold;
        }

        /* Column widths */
        .col-party { width: 30%; }
        .col-equal { width: 12%; }
        .col-date { width: 15%; }
        .col-remarks { width: 19%; }

      </style>
    </head>
    <body>

      <div class="report-wrapper">

       <div class="header-section">

  <div class="company-section">
    <div class="title">ORANGE TRADINGS</div>
    <div class="sub-title">DHARAPURAM ROAD, TIRUPUR - 641 601</div>
  </div>

  <div class="date-section">
    <div>From Date : ${fromDate}</div>
    <div>To Date&nbsp;&nbsp;&nbsp;: ${toDate}</div>
  </div>

</div>


        <table>
          <thead>
            <tr>
              <th class="col-party">Party Name</th>
              <th class="col-equal">Inv No</th>
              <th class="col-date">Date</th>
              <th class="col-equal">Amount</th>
              <th class="col-equal">Recamt</th>
              <th class="col-equal">Balance</th>
              <th class="col-remarks">Remarks</th>
            </tr>
          </thead>

          <tbody>
            ${data.map(row => `
              <tr>
                <td>${row.partyName}</td>
                <td>${row.invoiceNo}</td>
                <td>${row.date ? new Date(row.date).toLocaleDateString("en-GB") : "-"}</td>
                <td>${Number(row.amount).toFixed(2)}</td>
                <td>${Number(row.receipt).toFixed(2)}</td>
                <td>${Number(row.balance).toFixed(2)}</td>
                <td>${row.remarks || ""}</td>
              </tr>
            `).join("")}
          </tbody>

          <tfoot>
            <tr>
              <td colspan="3">Total</td>
              <td>${totalAmount.toFixed(2)}</td>
              <td>${totalReceipt.toFixed(2)}</td>
              <td>${totalBalance.toFixed(2)}</td>
              <td></td>
            </tr>
          </tfoot>
        </table>

      </div>

    </body>
    </html>
  `);

  printWindow.document.close();

  printWindow.onload = function () {
    printWindow.focus();
    printWindow.print();
    printWindow.close();   // ✅ Auto close after print
  };
};





  const handleClear = () => {
    setSalesType("ALL");
    setSelectedParty("");
    setSelectedPartyId(null);
 
  };


 
  // ================= FILTER MODE =================
  return (
    <div className="report-container">

      <div className="report-card">
        <h2 className="report-title">SALES REPORT</h2>

        <div className="form-group">
          <label>Sales Type</label>
          <select
            value={salesType}
            onChange={(e) => {
              setSalesType(e.target.value);
              setSelectedPartyId(null);
            }}
          >
            <option value="ALL">All Party</option>
            <option value="PARTY">Party Wise</option>
          </select>
        </div>

        {salesType === "PARTY" && (
          <div className="form-group">
            <label>Party</label>
            <input
              type="text"
              value={selectedParty}
              readOnly
              placeholder="Select Party"
              onClick={() => {
                setShowPartyPopup(true);
                setPartySearch("");
                setActiveIndex(0);
              }}
            />
          </div>
        )}

       
        <div className="btn-group">
          <button onClick={handlePrint}>Print</button>
          <button onClick={handleClear}>Clear</button>
        </div>

       


        {showPartyPopup && (
  <div className="popup-overlay">
    <div className="popup-box" ref={popupRef}>
      <div className="popup-header">
        <span>Select Invoice Party</span>
        <button onClick={() => setShowPartyPopup(false)}>✕</button>
      </div>

      <input
        className="popup-search"
        autoFocus
        value={partySearch}
        onChange={e => {
          setPartySearch(e.target.value);
          setActiveIndex(0);
        }}
      />

      <div className="popup-list">
        {filteredParties.length === 0 && (
          <div className="popup-empty">
            No party found
          </div>
        )}

        {filteredParties.map((p, i) => (
  <div
    key={p.id}
    className={`popup-row ${i === activeIndex ? "active" : ""}`}
    onClick={() => selectParty(p)}
  >
    {p.partyName}   
  </div>
))}

      </div>
    </div>
  </div>
)}

      </div>

    </div>
  );
}
